import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import Chip from '@mui/material/Chip';
import { useEffect, useState } from 'react';

function formatNow(date) {
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'medium',
  }).format(date);
}

export default function LiveClock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Chip
      icon={<AccessTimeRoundedIcon />}
      label={formatNow(now)}
      variant="outlined"
      sx={{
        height: 46,
        px: 0.5,
        borderRadius: 1.5,
        bgcolor: 'background.default',
        '& .MuiChip-label': { fontWeight: 700 },
      }}
    />
  );
}
